import {DATA_CONSTANTS} from "../constants/data-constants";


const GLOBAL_ACTIONS = {

    setPopularGamesAction: (data) => {
        return {
            type: DATA_CONSTANTS.SET_POPULAR_GAMES,
            data,
        };
    },


    setHighRtpGames: (data) => {
        return {
            type: DATA_CONSTANTS.SET_HIGH_RTP_GAMES,
            data,
        };
    },

    setBuyBonusGames: (data) => {
        return {
            type: DATA_CONSTANTS.SET_BUY_BONUS_GAMES,
            data,
        };
    },
    setMiniGames: (data) => {
        return {
            type: DATA_CONSTANTS.SET_MINI_GAMES,
            data,
        };
    },

    setSliders: (data) => {
        return {
            type: DATA_CONSTANTS.SET_SLIDERS,
            data,
        };
    },

    setScripts: (data) => {
        return {
            type: DATA_CONSTANTS.SET_SCRIPTS,
            data,
        };
    },


    setMiniSliders: (data) => {
        return {
            type: DATA_CONSTANTS.SET_MINI_SLIDERS,
            data,
        };
    },



    setMiniBanners: (data) => {
        return {
            type: DATA_CONSTANTS.SET_MINI_BANNERS,
            data,
        };
    },


    setProviderList: (data) => {
        return {
            type: DATA_CONSTANTS.SET_PROVIDER_LIST,
            data,
        };
    },


    setVipStates: (data) => {
        return {
            type: DATA_CONSTANTS.SET_VIP_STATES,
            data,
        };
    },


    setFaqs: (data) => {
        return {
            type: DATA_CONSTANTS.SET_FAQS,
            data,
        };
    },

    setBlogs: (data) => {
        return {
            type: DATA_CONSTANTS.SET_BLOGS,
            data,
        };
    },


    setPromotions: (data) => {
        return {
            type: DATA_CONSTANTS.SET_PROMOTIONS,
            data,
        };
    },





    setNewGamesAction: (data) => {
        return {
            type: DATA_CONSTANTS.SET_NEW_GAMES,
            data,
        };
    },


    setLiveCasinoGamesAction: (data) => {
        return {
            type: DATA_CONSTANTS.SET_LIVE_CASINO_GAMES,
            data,
        };
    },

    setTopGames: (data) => {
        return {
            type: DATA_CONSTANTS.SET_TOP_GAMES,
            data,
        };
    },


    setFreespinGames: (data) => {
        return {
            type: DATA_CONSTANTS.SET_FREESPIN_GAMES,
            data,
        };
    },

    setJackpotGames: (data) => {
        return {
            type: DATA_CONSTANTS.SET_JACKPOT_GAMES,
            data,
        };
    },

    setSportsbookGames: (data) => {
        return {
            type: DATA_CONSTANTS.SET_SPORTSBOOK_GAMES,
            data,
        };
    },

    setGameShows: (data) => {
        return {
            type: DATA_CONSTANTS.SET_GAME_SHOWS,
            data,
        };
    },


}


export default GLOBAL_ACTIONS
